export default class Params {
    static ins(){
        return new this();
    }
    constructor() {
        this._where = [];
        this._field = [];
        this._join = [];
        this._group = [];
        this._order = [];
        this._page = 1;
        this._size = 20;
    }

    // 链式条件
    where(option = null) {
        if (!option) return this;

        if (Array.isArray(option)) {
            if (option.length === 3) {
                this._where.push({ field: option[0], op: option[1], value: option[2] });
            } else if (option.length === 2) {
                this._where.push({ field: option[0], op: '=', value: option[1] });
            }
        } else if (typeof option === 'object') {
            const key = Object.keys(option)[0];
            this._where.push({ field: key, op: '=', value: option[key] });
        }
        return this;
    }

    field(field = []) {
        if (!field) return this;
        this._field = Array.isArray(field) ? field : field.split(',');
        return this;
    }

    join(join = []) {
        if (!join) return this;
        this._join = Array.isArray(join) ? join : [join];
        return this;
    }

    group(group = []) {
        if (!group) return this;
        this._group = Array.isArray(group) ? group : group.split(',');
        return this;
    }

    order(order = []) {
        if (!order) return this;
        this._order = Array.isArray(order) ? order : [order];
        return this;
    }

    page(page = 1) {
        this._page = page;
        return this;
    }

    size(size = 20) {
        this._size = size;
        return this;
    }

    // ========== 输出参数并自动销毁当前实例 ==========
    list() {
        const data = {
            where: this._where,
            field: this._field,
            join: this._join,
            group: this._group,
            order: this._order,
            page: this._page,
            size: this._size
        };
        // 自动清空引用，帮助GC回收
        this._clear();
        return data;
    }

    detail(id) {
        const data = {
            id,
            field: this._field,
            join: this._join,
            group: this._group
        };
        this._clear();
        return data;
    }

    save(data) {
        this._clear();
        return data;
    }

    delete(id) {
        this._clear();
        return { id };
    }

    // 自动清空
    _clear() {
        this._where = this._field = this._join = this._group = this._order = [];
        this._page = 1;
        this._size = 20;
    }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Config/PosDevice/common/Params.js